import React, { useState, useContext, } from 'react';
import { Form, Space, Select, Input, } from 'antd';
import { Status } from '../../Status/Status.component';
import { DeviceButtonGroup } from '../DeviceButtonGroup.component';
import { DeleteDeviceModal } from '../../../Modals/DeleteDeviceModal.component.';
import { getDeviceTitle } from '../DevicesList/DevicesList.component';
import { DeleteDeviceButton } from '../DeleteDeviceButton.component';
import { GroupedDevicesTable, SerialNumCell, } from '../GroupedDevicesTable.component';
import { DeviceRestrictedInput } from '../DeviceRestrictedInput.component';
import { PermissionsContext } from '../../../../../router/DashboardRoutes';
import { EthernetPorts } from '../../EthernetPorts/EthernetPorts.component';

const { Option } = Select;

export const CSEVC = ({ data, isPanelPending, saveChanges, renderEditableCellValue, profileCombination, ...props}) => {

    const userPermissions = useContext(PermissionsContext);
    const isPCI = userPermissions.server.pci;

    const [deleteModal, setDeleteModal] = useState({display: false, record: ''});
    const [currentDevice, setCurrentDevice] = useState();

    const deleteDevice = (record) => {
        setDeleteModal({display: true, record: record});
    }

    const columns = [
        {
            title: 'Serial Number',
            dataIndex: 'serialNum',
            key: 'serialNum',
            width: 150,
            render: (value, record) => {
                return (
                    <SerialNumCell panelPending={isPanelPending(record)} value={value}/>
                )
            }
        },
        {
            title: 'Description',
            dataIndex: 'comment',
            key: 'comment',
            render: (value, record) => renderEditableCellValue(value, record, 'comment')
        },
        {
            title: 'Ethernet Ports',
            dataIndex: '',
            key: 'ethernetPorts',
            render: (record) => {
                return <EthernetPorts data={record}/>
            },
            ellipsis: true,
        },
        {
            title: 'CPU', 
            dataIndex: 'cpu', 
            key: 'cpu', 
            ellipsis: true,
        },
        {
            title: 'Temperature', 
            dataIndex: 'temperature',
            key: 'temperature',
        },
        {
            title: 'Voltage',
            dataIndex: 'voltage', 
            key: 'voltage'
        },
        {
            title: 'Firmware Version',
            dataIndex: 'version',
            key: 'version',
        },
        {
            title: 'OS Version',
            dataIndex: 'routerversion',
            key: 'routerversion',
        },
        {
            title: 'VPN Mode', 
            dataIndex: 'licensed', 
            key: 'licensed', 
            render: (record) => {
                return record ? 'ON' : 'OFF'
            }
        },
        {
            title: 'VPN Status', 
            dataIndex: 'status',
            key: 'status',
            width: 120,
            render: (status) => {
                return <Status status={status}/>
            },
        },
        {
            title: 'IPs', 
            dataIndex: 'ips', 
            key: 'ips', 
            ellipsis: true,
            render: (_, record) => {
                return (
                    <EthernetPorts data={record} modal={true}/>
                );
            },
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (_, record) => {
                return (
                    <Space size='small' onClick={(e) => e.stopPropagation()}>
                        <DeviceButtonGroup serialNum={record.serialNum} status={record.status} hostTable={record.deviceType !== 'CSBASE'} ant winbox/>
                        <DeleteDeviceButton pending={isPanelPending(record)} onClick={() => deleteDevice(record)} />
                    </Space>
                );
            },
        },
    ];

    const formItems = (
        <>
            <DeviceRestrictedInput label='Description:' name='comment'  >
                <Input/>
            </DeviceRestrictedInput>
            <DeviceRestrictedInput label='CPU:' name='cpu'>
                <Input disabled/>
            </DeviceRestrictedInput>
            <DeviceRestrictedInput label='Temperature:' name='temperature'>
                <Input disabled/>
            </DeviceRestrictedInput>
            <DeviceRestrictedInput label='Voltage:' name='voltage'>
                <Input disabled/>
            </DeviceRestrictedInput>
            <DeviceRestrictedInput label='Firmware Version:' name='version'>
                <Input disabled/>
            </DeviceRestrictedInput>
            <DeviceRestrictedInput label='OS Version:' name='routerversion'>
                <Input disabled/>
            </DeviceRestrictedInput>
            <Form.Item label='VPN Mode:' name='licensed'>
                <Select>
                    <Option value={0}>OFF</Option>
                    <Option value={1}>ON</Option>
                </Select>
            </Form.Item>
        </>
    );

    return (
        <>
            <GroupedDevicesTable
                columns={columns}
                dataSource={data}
                formItems={formItems}
                isPanelPending={isPanelPending}
                saveChanges={saveChanges}
                currentDevice={currentDevice}
                setCurrentDevice={setCurrentDevice}
            />

            { deleteModal.display && 
                <DeleteDeviceModal 
                    title={getDeviceTitle(deleteModal.record.deviceType)} 
                    item={deleteModal.record} 
                    visible={deleteModal.display} 
                    setVisible={setDeleteModal}>
                </DeleteDeviceModal>
            }
        </>
    );
}
